<template>
    <div class="pondSetting">
      
       <div class="content-container">
          <div class="titieMian">
            <div class="title-container">塘口设置</div>
            <div class="select-container">
              <div class="select-container-box">
                <span>基地&nbsp;&nbsp;</span>
                <el-select v-model="fishBaseName" filterable placeholder="请选择"  size="small">
                  <el-option
                    v-for="(item, index) in selectBaseList"
                    :key="index"
                    :label="item.value"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="select-container-box">
                <span>在&nbsp;&nbsp;</span>
                <el-select v-model="zone" filterable placeholder="请选择"  size="small">
                  <el-option
                    v-for="(item, index) in zoneList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="select-container-box">
                <span>查找&nbsp;&nbsp;</span>
                <el-input
                  placeholder="请输入关键字"
                  v-model="changeName"
                  size="small"
                  class="search-input"
                  type="text"
                  :maxlength="num"
                  onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                  clearable>
                </el-input>
              </div>
              <div class="select-container-box" >
                <el-button size="small"  type="info" plain @click="getPondData(1)" class="query" >查询</el-button>
                <el-button size="small"  type="info" plain @click="add" class="add" v-if="edit">增加</el-button> 
              </div>   
            </div>
          </div>
          <div class="table-container">
            <el-table
              :data="pondData.list"
              style="width:100%;"
              size="medium"
              @row-dblclick="dataBackFillGoods"
              :default-sort = "{prop: 'date', order: 'descending'}">
               <i slot="empty" style="font-style:normal">暂无数据</i>
              <el-table-column
                prop="date"
                label="日期"
                width="170"
                align="center"
                :formatter="dataFormatter"
                >
              </el-table-column>
              <el-table-column
                prop="fishBaseName"
                label="基地名称"
                align="center"
                show-overflow-tooltip
                :filters="getFilterList"
                :filter-method="filterHandler">
              </el-table-column>
              <el-table-column
                prop="fishPondNo"
                label="塘口编号"
                align="center"
                :filters="getFilterPondList"
                :filter-method="filterHandler"
                show-overflow-tooltip
                >
              </el-table-column>
              <el-table-column
                prop="fish"
                label="主养品种"
                align="center"
                :filters="getFilterFishList"
                :filter-method="filterHandler"
              >
              </el-table-column>
              <el-table-column
                prop="area"
                align="center"
               
                label="塘口面积">
              </el-table-column>
                <el-table-column
                prop="avgDeep"
                align="center"
                label="平均水深">
              </el-table-column>
              <el-table-column
                prop="leader"
                label="负责人"
                align="center">
              </el-table-column>
              <el-table-column
                prop="phone"
                align="center"   
                show-overflow-tooltip            
                label="联系方式">
              </el-table-column>
              <el-table-column label="操作" align="center" width="170">
                <template slot-scope="scope">
                  <span
                    @click="handleEdit(scope.$index, scope.row)" class="content-edit">{{edit?"编辑":"查看"}}</span>
                  <span
                    @click="handleDelete(scope.$index, scope.row)" class="content-del" v-if="edit">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <page-change :pageInfo="pageInfo"></page-change> 
          <!-- 弹窗 -->
          <div v-if="dialogFormVisible" >
            <el-dialog :title="titleName"  :visible.sync="dialogFormVisible"  width="766px" >
              <el-form :model="ruleForms" :rules="rules" ref="ruleForms" class="ruleForms">
                <el-form-item label="所在基地" prop="fishBaseId" :label-width="formLabelWidth">
                  <el-select v-model="ruleForms.fishBaseId" filterable placeholder="请选择所在基地" :disabled="!edit" @change="chooseFishBase">
                    <el-option v-for="(item,index) in baseList" :key="index" :label="item.value" :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="塘口编号" prop="pondNumber" :label-width="formLabelWidth">
                  <el-input v-model="ruleForms.pondNumber" :disabled="!edit"  placeholder="请输入塘口编号" type="text" :maxlength="num" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
                </el-form-item>
                <el-row>
                  <el-form-item label="主养品种" required :label-width="formLabelWidth">
                    <el-col :span="9">
                      <el-form-item prop="fishCategoryId" class="fisherr">
                        <el-select v-model="fishCategoryList" filterable :disabled="!edit"  class="fishType" placeholder="请选择鱼分类名称" @change="changeFishGetCategory">
                          <el-option 
                            v-for="item in fishGetCategory" 
                            :key="item.key" 
                            :label="item.value" 
                            :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="9" v-if="fishCategoryList" >
                      <el-form-item prop="fishName" >
                        <el-select v-model="ruleForms.fishName" filterable :disabled="!edit"  class="fishName" @change="getFishName" placeholder="请选择鱼种类型" >
                          <el-option 
                            v-for="item in fishGetCategoryName"
                            :key="item.key" 
                            :label="item.value" 
                            :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="养殖类型" required :label-width="formLabelWidth" class="fisherr">
                    <el-col :span="9">
                      <el-form-item prop="cultivationTypeId">
                        <el-select v-model="ruleForms.cultivationTypeId" filterable :disabled="!edit"  class="fishType" placeholder="请选择养殖类型" >
                          <el-option v-for="item in cultureTypeList" :key="item.id" :label="item.name" :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="9">
                      <el-form-item prop="fishTypeId" class="fisherr">
                        <el-select v-model="ruleForms.fishTypeId" filterable :disabled="!edit"  class="fishName" placeholder="请选择渔种类型">
                          <el-option v-for="item in fishTypeList" :key="item.id" :label="item.name" :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-form-item>
                </el-row>
                <el-form-item label="养殖模式" prop="modeId" :label-width="formLabelWidth">
                  <el-select v-model="ruleForms.modeId" filterable :disabled="!edit"  placeholder="请选择养殖模式" >
                    <el-option 
                    v-for="item in cultureModeList" 
                    :key="item.id" 
                    :label="item.name" 
                    :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="塘口面积" prop="pondArea" :label-width="formLabelWidth">
                  <el-input v-model="ruleForms.pondArea" :disabled="!edit"  type="text" :maxlength="num1"  placeholder="请输入面积"  onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;">
                    <i slot="suffix" style="font-style:normal">亩</i>
                  </el-input>
                </el-form-item>
                <el-form-item label="平均水深" prop="avgDeep" :label-width="formLabelWidth">
                  <el-input v-model="ruleForms.avgDeep" :disabled="!edit" type="text" :maxlength="num1" placeholder="请输入水深" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;">
                    <i slot="suffix" style="font-style:normal">米</i>
                  </el-input>
                </el-form-item>
                <el-form-item label="负责人" prop="leaderId" :label-width="formLabelWidth">
                  <el-select v-model="ruleForms.leaderId" filterable :disabled="!edit" placeholder="请选择负责人" >
                    <el-option v-for="item in companyUser" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer" v-if="edit">
                <el-button @click="cancel('ruleForms')" >取 消</el-button>
                <el-button type="primary" @click="save('ruleForms')" v-if="this.titleName === '添加塘口信息'">保 存</el-button>
                <el-button type="primary" @click="saveEdit('ruleForms')" v-if="this.titleName === '编辑塘口信息' ">保 存</el-button>
              </div>
            </el-dialog>  
          </div>
         
       </div>
    </div>
</template>


<script>
import PageChange from "../../../common/PageChange";
import { mapActions, mapState } from "vuex";
import { modules } from "../../../../store";
import checkPermission from "../../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "pondSetting",
  mixins: [mixins],
  components: {
    PageChange
  },
  data() {
    return {
      num: 20,
      num1: 7,
      formLabelWidth: "80px",
      titleName: "",
      dialogFormVisible: false,
      fishCategoryList: "", // 鱼分类选
      fishNameList: "", // 鱼名称
      ruleForms: {
        fishBaseId: "", //所在基地
        pondNumber: "", //塘口编号
        fishCategoryId: "", // 鱼分类名称
        fishCategoryName: "",
        fishId: "", // 鱼分类ID
        fishName: "", // 鱼分类名称
        cultivationTypeId: "", // 养殖类型
        fishTypeId: "", // 渔种类型
        modeId: "", // 养殖模式
        pondArea: "", //塘口面积
        avgDeep: "", //平均水深
        leaderId: "" // 塘口负责人
      },
      cultureTypeList: [], //养殖类型
      fishTypeList: [], //渔种类型
      cultureModeList: [], //养殖模式
      companyUser: [], //负责人
      baseList: [], //基地
      rules: {
        fishBaseId: [
          { required: true, message: "请输入所在基地", trigger: "change" }
        ],
        pondNumber: [
          { required: true, message: "请输入塘口编号", trigger: "blur" },
          // {
          //   pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
          //   message: "塘口编号格式不对,请重新输入"
          // }
        ],
        fishCategoryId: [
          { required: true, message: "请选择鱼分类名称", trigger: "change" }
        ],
        fishId: [
          { required: true, message: "请选择鱼种名称", trigger: "change" }
        ],
        cultivationTypeId: [
          { required: true, message: "请选择养殖类型", trigger: "change" }
        ],
        fishTypeId: [
          { required: true, message: "请选择渔种类型", trigger: "change" }
        ],
        modeId: [
          { required: true, message: "请选择养殖模式", trigger: "change" }
        ],
        pondArea: [
          { required: true, message: "请输入塘口面积", trigger: "blur" },
          {
            pattern: /^[0-9]{1,6}([.][0-9]{1,2})?$/,
            message: "塘口面积格式不对,请重新输入"
          }
        ],
        avgDeep: [
          { required: true, message: "请输入平均水深", trigger: "blur" },
          {
            pattern: /^[0-9]{1,4}([.][0-9]{1,2})?$/,
            message: "平均水深格式不对,请重新输入"
          }
        ],
        leaderId: [
          { required: true, message: "请选择塘口负责人", trigger: "change" }
        ]
      },
      pid: "",
      edit: "",

      zone: "", //切换监听
      zoneList: [
        {
          value: "",
          label: "全部"
        },
        // {
        //   value: "fishBaseName",
        //   label: "基地名称"
        // },
        {
          value: "leader",
          label: "负责人"
        },
        {
          value: "fishPondNo",
          label: "塘口编号"
        }
      ],
      changeName: "", //改变名
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.getPondData, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      },
      rowId: "",
      fishBaseName: "全部",
      selectBaseList: [],
    };
  },

  methods: {
    ...mapActions(modules.pond, [
      "getPondList", //获取全部塘口数据
      "delPondList", //删除数据
      "addPondSettingList", //添加
      "getEditPondData", //获取塘口单行数据
      "editPondSettingList" //编辑-保存数据
    ]),
    ...mapActions(modules.user, ["getCompanyUser", "getEmployees", "getEmployeesByFishBase"]),
    ...mapActions(modules.fish, [
      "getFishGetCategory", // 获取渔种信息
      "getFishGetCategoryName" // 获取分类渔种名称
    ]),
    ...mapActions(modules.base, ["getBaseList", "getAllBaseList"]), //基地
    ...mapActions(modules.dataDict, [
      "getCultureType", //养殖类型
      "getFishType", //渔种类型
      "getCultureMode" //养殖模式
    ]),

    //查询数据
    getPondData(pageNum) {
      let obj = {
        // [this.zone]: this.changeName,
        pageIndex: (this.pageInfo.pageNumber = pageNum || 1),
        pageSize: this.pageInfo.pageSize,
        fishBaseName: this.fishBaseName === '全部'? '' : this.fishBaseName
      };
      if (this.zone !== "") {
        obj[this.zone] = this.changeName;
      } else {
        obj.leader = this.changeName;
        obj.fishPondNo = this.changeName;
      }
      this.getPondList(obj)
        .then(rsp => {
          this.pageInfo.totalPages = rsp.data.total;
          // console.dir(rsp);
        })
        .catch(err => {
          console.dir(err);
        });
    },
    //时间格式化
    dataFormatter(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return this.$timeformatDay(row.date);
      // return moment(date).format("YYYY-MM-DD");
    },
    // 字段筛选过滤
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },

    //切换分类---
    changeFishGetCategory(val) {
      this.ruleForms.fishCategoryName = val.value;
      this.ruleForms.fishCategoryId = val.key;
      this.getFishGetCategoryName(this.ruleForms.fishCategoryId)
        .then(rsp => {
          if (rsp.status === 200) {
            this.fishNameList = "";
            this.ruleForms.fishName = "";
            this.ruleForms.fishId = "";
          }
        })
        .catch(err => {
          console.dir(err);
        });
    },
    //获取鱼名称
    getFishName(val) {
      this.ruleForms.fishName = val.value;
      this.ruleForms.fishId = val.key;
    },
    //获取鱼分类
    getFishNameData() {
      this.getFishGetCategory()
        .then(rsp => {
          console.log(rsp);
        })
        .catch(err => {
          console.dir(err);
        });
    },
    // 选择基地
    async chooseFishBase(e) {
      console.log(e);
      let res = await this.$api.getPondByFish(e);
      console.log(res.data);
      let data = res.data;
      if (data.fishCategoryId > 0) {
        this.fishCategoryList = data.fishCategoryName;
        this.ruleForms.fishCategoryName = data.fishCategoryName;
        this.ruleForms.fishCategoryId = data.fishCategoryId;
        this.ruleForms.fishName = data.fishName;
        this.fishNameList = data.fishName;
        this.ruleForms.fishId = data.fishId;
        this.getFishGetCategoryName(data.fishCategoryId);
      }
    },
    //添加
    async add() {
      this.dialogFormVisible = true;
      this.fishCategoryList = "";
      this.ruleForms = {
        fishBaseId: "", //所在基地
        pondNumber: "", //塘口编号
        fishCategoryId: "", // 鱼分类名称
        fishCategoryName: "",
        fishId: "", // 鱼分类ID
        fishName: "", // 鱼分类名称
        cultivationTypeId: "", // 养殖类型
        fishTypeId: "", // 渔种类型
        modeId: "", // 养殖模式
        pondArea: "", //塘口面积
        avgDeep: "", //平均水深
        leaderId: "" // 塘口负责人
      };
      this.titleName = "添加塘口信息";
      this.baseList = await this.getBaseList(); //基地信息
      console.log(this.baseList, '---------------------------')
      this.ruleForms.fishBaseId = this.baseList[0].key;
      this.chooseFishBase(this.baseList[0].key);
      // this.companyUser = await this.getEmployees(); //获取负责人
      this.companyUser = await this.getEmployeesByFishBase(this.ruleForms.fishBaseId)
      console.log(this.companyUser, "???")
      this.cultureTypeList = await this.getCultureType(); //养殖类型
      this.ruleForms.cultivationTypeId = 3000
      this.fishTypeList = await this.getFishType(); //渔种类型
      this.ruleForms.fishTypeId = 4000
      this.getFishNameData(); //渔种名称
      this.cultureModeList = await this.getCultureMode(); //养殖模式
      this.ruleForms.modeId = 1001
    },
    //取消
    cancel(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
      this.fishCategoryList = "";
      this.ruleForms = {
        fishBaseId: "", //所在基地
        pondNumber: "", //塘口编号
        fishCategoryId: "", // 鱼分类名称
        fishCategoryName: "",
        fishId: "", // 鱼分类ID
        fishName: "", // 鱼分类名称
        cultivationTypeId: "", // 养殖类型
        fishTypeId: "", // 渔种类型
        modeId: "", // 养殖模式
        pondArea: "", //塘口面积
        avgDeep: "", //平均水深
        leaderId: "" // 塘口负责人
      };
    },
    //保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            fishBaseId: this.ruleForms.fishBaseId,
            no: this.ruleForms.pondNumber,
            fishCategoryId: this.ruleForms.fishCategoryId,
            fishCategoryName: this.ruleForms.fishCategoryName,
            fishName: this.ruleForms.fishName,
            fishId: this.ruleForms.fishId,
            cultivationTypeId: this.ruleForms.cultivationTypeId,
            fishTypeId: this.ruleForms.fishTypeId,
            modeId: this.ruleForms.modeId,
            area: this.ruleForms.pondArea,
            avgDeep: this.ruleForms.avgDeep,
            leaderId: this.ruleForms.leaderId
          };
          this.addPondSettingList(obj)
            .then(rsp => {
              if (rsp.status === 200) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.ruleForms = {
                  fishBaseId: "", //所在基地
                  pondNumber: "", //塘口编号
                  fishCategoryId: "", // 鱼分类名称
                  fishCategoryName: "",
                  fishId: "", // 鱼分类ID
                  fishName: "", // 鱼分类名称
                  cultivationTypeId: "", // 养殖类型
                  fishTypeId: "", // 渔种类型
                  modeId: "", // 养殖模式
                  pondArea: "", //塘口面积
                  avgDeep: "", //平均水深
                  leaderId: "" // 塘口负责人
                };
                this.getPondData();
                this.dialogFormVisible = false;

                this.$refs[formName].resetFields();
              }
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //获取当前行数据
    async handleEdit(index, row) {
      this.dialogFormVisible = true;
      if (this.edit) {
        this.titleName = "编辑塘口信息";
      } else {
        this.titleName = "查看塘口信息";
      }
      let rsp = await this.getEditPondData(row.id)
      if (rsp.status === 200) {
        this.getFishGetCategoryName(rsp.data.fishCategoryId);
        this.ruleForms = rsp.data || [];
        this.fishCategoryList = rsp.data.fishCategoryName;
        this.fishNameList = rsp.data.fishName;
      }
      let baseList = await this.getBaseList(); //基地信息
      this.baseList = baseList;
      // let result = await this.getEmployees(1); //获取负责人
      let result = await this.getEmployeesByFishBase(this.ruleForms.fishBaseId)
      this.companyUser = result;
      let cultureTypeList = await this.getCultureType(); //养殖类型
      this.cultureTypeList = cultureTypeList;
      let fishTypeList = await this.getFishType(); //渔种类型
      this.fishTypeList = fishTypeList;
      let cultureModeList = await this.getCultureMode(); //养殖模式
      this.cultureModeList = cultureModeList;
      // this.fishGetCategory = await this.getFishGetCategory();
      this.getFishNameData(); //渔种名称
      this.rowId = row.id;
    },
    //更新
    saveEdit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            id: this.rowId, //行id
            fishBaseId: this.ruleForms.fishBaseId,
            no: this.ruleForms.pondNumber,
            area: this.ruleForms.pondArea,
            fishCategoryId: this.ruleForms.fishCategoryId,
            fishId: this.ruleForms.fishId,
            fishCategoryName: this.ruleForms.fishCategoryName,
            fishName: this.ruleForms.fishName,
            cultivationTypeId: this.ruleForms.cultivationTypeId,
            fishTypeId: this.ruleForms.fishTypeId,
            modeId: this.ruleForms.modeId,
            avgDeep: this.ruleForms.avgDeep,
            leaderId: this.ruleForms.leaderId
          };
          this.editPondSettingList(obj)
            .then(rsp => {
              console.dir(rsp);
              if (rsp.status === 200) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.ruleForms = {
                  fishBaseId: "", //所在基地
                  pondNumber: "", //塘口编号
                  fishCategoryId: "", // 鱼分类名称
                  fishCategoryName: "",
                  fishId: "", // 鱼分类ID
                  fishName: "", // 鱼分类名称
                  cultivationTypeId: "", // 养殖类型
                  fishTypeId: "", // 渔种类型
                  modeId: "", // 养殖模式
                  pondArea: "", //塘口面积
                  avgDeep: "", //平均水深
                  leaderId: "" // 塘口负责人
                };
                this.getPondData(Number(localStorage.getItem("pageNumber")));
                this.dialogFormVisible = false;
              }
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //双击进入编辑页面
    async dataBackFillGoods(row, event) {
      this.dialogFormVisible = true;
      if (this.edit) {
        this.titleName = "编辑塘口信息";
      } else {
        this.titleName = "查看塘口信息";
      }
      this.getEditPondData(row.id)
        .then(rsp => {
          console.log(33, rsp);
          if (rsp.status === 200) {
            this.getFishGetCategoryName(rsp.data.fishCategoryId);
            this.ruleForms = rsp.data || [];
            this.fishCategoryList = rsp.data.fishCategoryName;
            this.fishNameList = rsp.data.fishName;
          }
          console.dir(rsp);
        })
        .catch(err => {
          console.dir(err);
        });
      let baseList = await this.getBaseList(); //基地信息
      this.baseList = baseList;
      // let result = await this.getEmployees(1); //获取负责人
      let result = await this.getEmployeesByFishBase(this.ruleForms.fishBaseId)
      this.companyUser = result;
      let cultureTypeList = await this.getCultureType(); //养殖类型
      this.cultureTypeList = cultureTypeList;
      let fishTypeList = await this.getFishType(); //渔种类型
      this.fishTypeList = fishTypeList;
      let cultureModeList = await this.getCultureMode(); //养殖模式
      this.cultureModeList = cultureModeList;
      // this.fishGetCategory = await this.getFishGetCategory();
      this.getFishNameData(); //渔种名称
      this.rowId = row.id;
    },
    //删除
    handleDelete(index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.rowId = row.id;
          await this.delPondList(this.rowId);
          this.getPondData(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error(err.response.data);
        });
    },
    async getBase2List() {
      const res = await this.getAllBaseList();
      this.selectBaseList = [
        {
          key: "-111",
          value: "全部"
        },
        ...res
      ]
    },
    async getBaseListFn(){
      this.baseList = await this.getBaseList(); //基地信息
    }
  },
  computed: {
    ...mapState(modules.pond, ["pondData"]),
    ...mapState(modules.fish, ["fishGetCategory", "fishGetCategoryName"]),
    //需要筛选的字段
    getFilterList() {
      const res = new Map();
      let fiterList = this.pondData.list
        .map(m => ({
          value: m.fishBaseName,
          text: m.fishBaseName
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    getFilterPondList() {
      const res = new Map();
      let fiterList = this.pondData.list
        .map(m => ({
          value: m.fishPondNo,
          text: m.fishPondNo
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    getFilterFishList() {
      const res = new Map();
      let fiterList = this.pondData.list
        .map(m => ({
          value: m.fish,
          text: m.fish
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    }
  },
  mounted() {
    console.log(mixins, this.companyList, 111);

    if (
      this.companyList.isQlwVersion == false ||
      this.companyList.isQlwVersion == null
    ) {
      let permission = this.loginUser.permissions.find(item => {
        return item.permissionId == this.permission.pondSetting;
      });
      if (permission) {
        this.edit = !permission.isReadOnly;
      }
    } else if (this.companyList.isQlwVersion == true) {
      checkPermission.checkEdit(this.$route).then(data => {
        this.edit = data;
      });
    }
    this.getPondData(1); //塘口数据
    this.getBase2List(); //塘口数据
    this.getBaseListFn() // 基地数据
  }
};
</script>
<style lang="stylus">
.pondSetting
  .el-dialog
    height:700px;
    position:absolute;
    left:50%;
    top:-50px;
    border-radius:6px;
    margin-left:-340px;
    .el-dialog__header 
      border-radius:6px 6px 0px 0px;
      padding: 16px 20px 16px;
      background:linear-gradient(270deg,rgba(51,137,255,1),rgba(31,156,244,1),rgba(49,170,255,1));
      .el-dialog__title 
        color: #fff;
    .el-input
      width:500px;
    .el-input__inner
      width:500px;
      margin-left:10px;
    .el-select.fishType .el-input , .el-select.fishName  .el-input
      width:245px!important;
    .el-select.fishType .el-input__inner, .el-select.fishName  .el-input__inner
      width:245px!important;
    .el-select.fishName
      margin-left:13px;
    .el-form-item__content
      z-index:999999;
      line-height: 40px;
      position: relative;
      font-size: 14px;
    .el-form .el-form-item .el-form-item__label
      margin-left:65px;
      color:#333;
      font-size:16px;
      text-align:right;
    .ruleForm
      margin-left 0px
    .el-dialog__close 
      color:#fff
    .el-dialog__footer
      position relative
      bottom:12px;
      padding:0px 0px 0px 0px;
      margin-right:370px;
    .el-button--primary
      margin-left:20px
      background: #3389ff;
    .el-button
      width 100px
      height 40px
    .el-button--default
      margin-left:117px
    .el-form-item .el-form-item__label:before
      position: absolute;
      top: 2px;
      left: -12px;
      color: #fe3223;
    .el-form-item__error
      padding-top: 2px;
      position: absolute;
      top: 100%;
      left: 74px;
    .el-icon-date
      position: relative;
    .el-icon-date:before {
      content: "\E608";
      position: absolute;
      left: 13px;
      top: 3px;
    }
    
</style>
